import React from 'react'

import './row.css'

const Row = ({ children, style, show }) => {
  return <div style={style} className={`row ${show ? show : "show"}`}>{children}</div>
}

export default Row
